<div class="d-flex justify-content-center" id="form-container">
  <div class="card mb-0">
    <form [formGroup]="loginForm" id="form" class="input-form">
      <label for="user-account-input" class="form-label">{{translate("user-account-label")}}</label>
      <div class="input-group input-group-merge" [ngClass]="{ 'is-invalid': isUserNameInValid }">
        <input type="text" id="user-account-input" #userAccountInput class="form-control" formControlName="userAccount"
          autocomplete="new-user" (focusout)="checkUserLoginUrl()" (keydown.enter)="checkLoginUrlAndTrySubmit($event)"
          [ngClass]="{ 'is-invalid': isUserNameInValid }" [placeholder]="translate('user-account-placeholder')" />
        <span class="input-group-text input-group-spinner" id="user-account-verification-indicator">
          <span class="input-spinner" [ngClass]="{ 'spinner-border': isUserNameCheckInProgress }"></span>
        </span>
      </div>
      <div *ngIf="isUserNameInValid" class="invalid-feedback" [innerHtml]="userAccountValidationErrors">
      </div>
      <div class="mt-1">
        <au-password-input id="password-input" [componentTranslationRoot]="componentTranslationRoot"
          formControlName="password" #passwordInput (enter)="tryTriggerSubmit($event)"></au-password-input>
      </div>
      <span id="forgot-password-container" class="w-100 d-flex justify-content-end"
        *ngIf="!passwordResetActivated;else spinner">
        <a class="primary" (click)="resetPassword()" id="passwordReset">
          <span>{{translate('forgot-password')}}</span>
        </a>
      </span>

      <div class="mb-1">
        <au-notification-bar #notificationBar> </au-notification-bar>
      </div>
      <div id="buttons-container">
        <button type="button" *ngIf="hasLoginAssistantHistory" id="back-button" rippleEffect
                class="btn round btn-outline-danger w-100" (click)="goToPreviousScreen()">
          <span><i class="feather icon-arrow-left"></i>{{translate('back', {}, 'common') }} </span>
        </button>

        <button type="submit" rippleEffect class="btn round btn-primary w-100" (click)="tryTriggerSubmit($event)"
                id="submit-button" [disabled]="isFormSubmitDisabled">{{ translate("login-button-text") }}
        </button>
      </div>
      <div>
        <div class="divider">
          <span>{{ translate("or") }}</span>
        </div>
        <button class="fw-bolder btn round btn-outline-primary text-primary w-100 d-flex align-items-center justify-content-center"
                (click)="openQrLogin()"
                id="qr-login-button">
          <svg-icon src="./assets/images/icon_qr_code.svg" [stretch]="false" class="qr-icon"></svg-icon>
          <span class="ms-50">{{ translate("qr-login-button") }}</span>
        </button>
      </div>
    </form>
  </div>
</div>

<ng-template #spinner>
  <span id="reset-password-spinner-container">
    <span class="input-spinner spinner-border text-primary"></span>
  </span>

</ng-template>
